import { render } from "./ListeAutreOrganisation.vue?vue&type=template&id=229c62d4"
import script from "./ListeAutreOrganisation.vue?vue&type=script&lang=js"
export * from "./ListeAutreOrganisation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__